import { cn } from "@/lib/utils";
import { Marquee } from "@/components/ui/marquee";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCursor } from "@/context/CursorContext";

export const Card = React.memo(({ card, index, hovered, setHovered }) => {
  const { setCursorVariant, setCursorText } = useCursor();

  const handleEnter = () => {
    setHovered(index);
    setCursorVariant("project");
    setCursorText("Visit");
  };

  const handleLeave = () => {
    setHovered(null);
    setCursorVariant("default");
    setCursorText("");
  };

  return (
    <Link to={card.link} target="_blank">
      <div
        onMouseEnter={handleEnter} // Use handleEnter here
        onMouseLeave={handleLeave} // Use handleLeave here
        className={cn(
          "rounded-md relative bg-gray-100 dark:bg-neutral-900 overflow-hidden aspect-square w-[240px] md:w-[360px] transition-all duration-300 ease-out",
          hovered !== null && hovered !== index && "blur-sm scale-[0.98]"
        )}
      >
        <img
          src={card.src}
          alt={card.title}
          fill="true"
          width={1251}
          height={834}
          className="object-cover aspect-square absolute inset-0"
        />
        <div
          className={cn(
            "absolute inset-0 bg-gradient-to-t from-background/60 to-background/0 flex items-end py-6 px-4 transition-opacity duration-300",
            hovered === index ? "opacity-100" : "opacity-0"
          )}
        >
          <div className="text-lg md:text-xl font-medium bg-clip-text text-transparent bg-gradient-to-b from-neutral-50 to-neutral-200">
            {card.title}
          </div>
        </div>
      </div>
    </Link>
  );
});

Card.displayName = "Card";

export default function WorkMarguee() {
  const [hovered, setHovered] = useState(null);

  const cards = [
    {
      title: "AJM Usługi Księgowe",
      src: "/images/ajm-mockup.webp",
      link: "https://ajm.waw.pl",
    },
    {
      title: "MT Doors",
      src: "/images/mtdoors-mockup.webp",
      link: "https://mtdoors.pl",
    },
    {
      title: "Centrum rolet",
      src: "/images/centrumrolet-mockup.webp",
      link: "https://centrumrolet.warszawa.pl",
    },
  ];

  return (
    <section>
      <div className="relative flex w-full flex-col items-center justify-center overflow-hidden py-8 lg:py-12">
        <Marquee pauseOnHover className="[--duration:20s] overflow-x-hidden">
          {cards.map((card, index) => (
            <Card
              className="project"
              key={index}
              card={card}
              index={index}
              hovered={hovered}
              setHovered={setHovered}
            />
          ))}
        </Marquee>

        <div className="pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-background"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-gradient-to-l from-background"></div>
      </div>
    </section>
  );
}
